import { gql } from '@apollo/client'
import { RichText, useToast } from '@farol-ds/react'
import {
  BOX_MODAL_IFRAME_URL,
  FEATURE_CODES,
  layoutStyles,
  useMetrics,
} from '@jusbrasil-web/docview/core'
import {
  CopyContentTriggerStandaloneFarol,
  CopyRequireLoginTrigger,
} from '@jusbrasil-web/shared-feature-locker-farol'
import { COMPONENT_CLASS, FEATURE_NAME } from '@jusbrasil-web/shared-ga4-events'
import { RefObject } from 'react'

import { Summary } from '../../summary'
import {
  ModelDocument_DocumentFragment,
  ModelDocument_ViewerFragment,
} from './__generated__/model-document.graphql'

export interface ModelDocumentProps {
  document: ModelDocument_DocumentFragment
  viewer: ModelDocument_ViewerFragment | null
  contentRef: RefObject<HTMLDivElement>
}

export function ModelDocument(props: ModelDocumentProps) {
  const { document, viewer, contentRef } = props
  const { metricsProperties } = useMetrics<HTMLDivElement>()
  const toast = useToast()

  const featureLockProps = {
    appId: 'web-docview',
    documentOrHaystackItem: document,
    featureCode: FEATURE_CODES.COPY_MODELOS_CONTENT,
    ssrEventsProperties: metricsProperties,
    viewer,
  }

  const ga4EventData = {
    componentClass: COMPONENT_CLASS.DOCUMENT_BODY_FULL_CONTENT,
    copyFeatureName: FEATURE_NAME.COPY_MODEL_CONTENT,
  }

  return (
    <>
      <Summary document={document} />

      <CopyRequireLoginTrigger {...featureLockProps} ga4EventData={ga4EventData}>
        <CopyContentTriggerStandaloneFarol
          {...featureLockProps}
          eventNamespace="ModeloPeca"
          onCopySuccess={toast}
          iframeUrl={BOX_MODAL_IFRAME_URL}
          ga4EventData={ga4EventData}
        >
          <RichText ref={contentRef} className={layoutStyles.contentWrapper}>
            <div dangerouslySetInnerHTML={{ __html: document.text || '' }} />
          </RichText>
        </CopyContentTriggerStandaloneFarol>
      </CopyRequireLoginTrigger>
    </>
  )
}

ModelDocument.fragments = {
  document: gql`
    fragment ModelDocument_document on Document {
      text(highlight: true)

      ...Summary_document
      ...CopyRequireLoginTrigger_document
      ...CopyContentTriggerStandaloneFarol_document
    }

    ${Summary.fragments.document}
    ${CopyRequireLoginTrigger.fragments.document}
    ${CopyContentTriggerStandaloneFarol.fragments.document}
  `,

  viewer: gql`
    fragment ModelDocument_viewer on Profile {
      ...CopyRequireLoginTrigger_viewer
      ...CopyContentTriggerStandaloneFarol_viewer
    }

    ${CopyRequireLoginTrigger.fragments.viewer}
    ${CopyContentTriggerStandaloneFarol.fragments.viewer}
  `,
}
